import { actionTypes } from '../actions/navigation.action'

const initialState = {
    screen: {
        open: false,
        type: null,
        props: {},
        match: {}
    },
    screenB: {
        open: false,
        type: null,
        props: {},
        match: {}
    },
    screenC: {
        open: false,
        type: null,
        props: {},
        match: {}
    }
}

const navigationReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.SCREEN:
        return { 
            ...state, 
            screen: {
                ...payload
            }
        }

    case actionTypes.SCREEN_B:
        return { 
            ...state, 
            screenB: {
                ...payload
            }
        }

    case actionTypes.SCREEN_C:
        return { 
            ...state, 
            screenC: {
                ...payload
            }
        }

    default:
        return state
    }
}

export default navigationReducer